import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex font-montserrat flex-col justify-center items-center" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "lg:h-[80px] h-[50px]" }, null, -1)
const _hoisted_4 = { class: "absolute z-[1000000] text-left bg-black/50 px-[20px] md:px-[50px] text-white top-0 left-0 right-0 bottom-0 w-full flex items-center flex-col justify-center" }
const _hoisted_5 = { class: "text-4xl md:text-6xl uppercase text-center font-bold opacity-100" }
const _hoisted_6 = { class: "container max-w-[1024px]" }
const _hoisted_7 = { class: "w-full relative flex justify-center items-center md:mt-[50px] mt-[20px]" }
const _hoisted_8 = { class: "container relative w-full md:my-[50px] my-[20px]" }
const _hoisted_9 = { class: "text-2xl my-[20px] font-bold text-center text-cyan-700 uppercase" }
const _hoisted_10 = { class: "w-full flex relative" }

import HeaderComponent from '../components/HeaderComponent.vue'
  import carouselBranding from '../components/CarouselBranding.vue'
  import One_trainings from '@/components/One_trainings.vue';
  import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
import FooterComponent from '@/components/FooterComponent.vue';
  const initialSlide = 1;

  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'trainingFC',
  setup(__props) {

  const router = useRouter()
  function goToTrainingSPage() {
      router.push('/trainingFS')
  }
  function goToTrainingCPage() {
      router.push('/trainingFC')
  }
  function goToTrainingPage() {
      router.push('/training')
  }
  const pageTitle = ref('IronSecur | Training'); 
  
  onMounted(() => {
      document.title = pageTitle.value; 
  });
  
  const trainings = ref([

    {   nam: 't4_nam', 
        target: 't4_target', 
        pre: 't4_pre', 
        PREstyle: 'hidden',
        edu: ["t4_edu1", "t4_edu2", "t4_edu3", "t4_edu4", "t4_edu5", "t4_edu6", "t4_edu7"], 
        image: "/img/training3.jpg", 
        booklet: '#', 
        PA: ["t4_PA1", "t4_PA2", "t4_PA3", "t4_PA4"], 
        Duration: ["t4_Duration1", "t4_Duration2", "t4_Duration3", "t4_Duration4"], 
        PR: ["t4_PR1", "t4_PR2", "t4_PR3", "t4_PR4", "t4_PR5"] 
    },
    {   nam: 't5_nam', 
        target: 't5_target', 
        pre: 't5_pre', 
        edu: ["t5_edu1", "t5_edu2", "t5_edu3", "t5_edu4", "t5_edu5", "t5_edu6", "t5_edu7"], 
        image: "/img/training.jpg", 
        booklet: '#', 
        PA: ["t5_PA1", "t5_PA2", "t5_PA3", "t5_PA4"], 
        Duration: ["t5_Duration1", "t5_Duration2", "t5_Duration3", "t5_Duration4"], 
        PR: ["t5_PR1", "t5_PR2", "t5_PR3", "t5_PR4", "t5_PR5"] 
    },

    {   nam: 't6_nam', 
        style: "md:leading-10",
        target: 't6_target', 
        pre: 't6_pre', 
        edu: ["t6_edu1", "t6_edu2", "t6_edu3", "t6_edu4", "t6_edu5", "t6_edu6", "t6_edu7"], 
        image: "/img/training4.jpg", 
        booklet: '#',
        PA: ["t6_PA1", "t6_PA2", "t6_PA3", "t6_PA4"], 
        Duration: ["t6_Duration1", "t6_Duration2", "t6_Duration3", "t6_Duration4"], 
        PR: ["t6_PR1", "t6_PR2", "t6_PR3", "t6_PR4", "t6_PR5"] 
    },
 
    {   nam: 't7_nam', 
        target: 't7_target', 
        pre: 't7_pre', 
        edu: ["t7_edu1", "t7_edu2", "t7_edu3", "t7_edu4", "t7_edu5", "t7_edu6", "t7_edu7"],  
        image: "/img/training5.jpg", 
        booklet: '#', 
        PA: ["t7_PA1", "t7_PA2", "t7_PA3", "t7_PA4"], 
        Duration: ["t7_Duration1", "t7_Duration2", "t7_Duration3", "t7_Duration4"], 
        PR: ["t7_PR1", "t7_PR2", "t7_PR3", "t7_PR4", "t7_PR5"] 
    },

        
  ]);
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(carouselBranding, { "initial-slide": initialSlide }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('training')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.$t('training')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", {
              onClick: goToTrainingPage,
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  ' border-cyan-700': _ctx.$route.path === '/training'
              })
            }, _toDisplayString(_ctx.$t('FD')), 3),
            _createElementVNode("span", {
              onClick: goToTrainingSPage,
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  ' border-cyan-700': _ctx.$route.path === '/trainingFS'
              })
            }, _toDisplayString(_ctx.$t('FS')), 3),
            _createElementVNode("span", {
              onClick: goToTrainingCPage,
              class: _normalizeClass({
                  'border-b-4 w-4/12 cursor-pointer md:min-w-[200px] px-[10px]': true, 
                  ' border-cyan-700': _ctx.$route.path === '/trainingFC'
              })
            }, _toDisplayString(_ctx.$t('FC')), 3)
          ]),
          _createVNode(One_trainings, { trainings: trainings.value }, null, 8, ["trainings"])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ]))
}
}

})